import {
  CloseButton,
  FormTitle,
  FunctionButtonContainer,
  HorizontalContainer,
  InfoArea,
  ScreenRoot,
  SmallTitleText,
  StyledPaper,
  StyledTable,
  TabButton,
  TabButtonSpan,
  TabContainer,
  VerticalContainer,
} from "../styles";
import { ProceedButtonContainer, TitleContainer } from "../uploader/styles";
import { LargeText, MediumText } from "../../styles";
import { StageList } from "../uploader";
import { FunctionalButton } from "../../../../components/functionalButton";
import React, { useEffect, useRef, useState } from "react";
import { useHistory, useLocation } from "react-router";
import { ActionButton } from "./styles";
import {
  getAuditTrailData,
  getLabellerData,
  getPdfDocsFromBucket,
  postTransferData,
  updateIdpDocumentCounter,
} from "../../../../api/external_data";
import { useDispatch } from "react-redux";
import Dialog from "@material-ui/core/Dialog";
import CloseIcon from "@material-ui/icons/Close";
import Success from "../../../../assets/dashboardIcons/Success";
import { getFiles, setFiles } from "./files";
import { AlertPopup } from "../../../../components/alertPopup/alertPopup";
import Spinner from "../../../../components/spinner";
import {
  StyledTableCell,
  StyledTableRow,
} from "../../../../components/filesListTable/styles";
import PylonIcon from "../../../../assets/common/pylonIcon.png";
import {
  getUnderwriterIdpActiveDocuments,
  getUnderwriterIdpArchivedDocuments,
} from "../../../../data/actions/underwriters";

const modelMappings = {
  profitAndLoss: "Profit and Loss",
  cashflow: "Cash Flow",
  balanceSheet: "Balance Sheet",
  workInProgress: "Work In Progress",
  workCompleted: "Work Completed",
};

export default function ParserIDP() {
  const location = useLocation();
  const history = useHistory();
  const dispatch = useDispatch();

  const {
    updatedFinancialData,
    selectedAccount,
    clientDocumentsId,
    splitFiles,
    editedDocuments,
    oldDocument,
    index,
    editedDocumentFiles,
    _labellerResponse,
  } = location.state || null;

  console.log("split files d", splitFiles);

  const [documents, setDocuments] = useState(editedDocuments || []);
  const [selectedTab, setSelectedTab] = useState("documents");
  const [auditTrail, setAuditTrail] = useState();
  const [documentFiles, setDocumentsFiles] = useState(getFiles() || []);
  const [isTransferDataDisabled, setIsTransferDataDisabled] = useState(false);
  const [showTransferDataPopup, setShowTransferDataPopup] = useState(false);
  const [showFailedTransferDataPopup, setShowFailedTransferDataPopup] =
    useState(false);
  const [previousResponse, setPreviousResponse] = useState([]);
  const isPollingForLabellerData = useRef(false);

  const [canEditSplitDisabled, setCanEditSplitDisabled] = useState(false);
  const [
    showDeleteDocumentTypeConfirmationPopup,
    setShowDeleteDocumentTypeConfirmationPopup,
  ] = useState(false);

  const [splitFilesData, setSplitFilesData] = useState(splitFiles);
  const [documentTypeToDelete, setDocumentTypeToDelete] = useState();
  const [allDataHasArrived, setAllDataHasArrived] = useState(false);
  const [labellerResponse, setLabellerResponse] = useState();

  const previousIdsRef = useRef(new Set());

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const ntld = urlParams.get("ntld") === "true";
    const TIMEOUT_THRESHOLD_IN_MINS = 10;

    const relevantSplitIds = splitFilesData.flatMap((file) =>
      file.splitFiles.map((split) => split.id),
    );

    if (!ntld) {
      let dataPollingInterval;
      let lastResponse = null;
      let unchangedSince = null;

      const accountDetails = {
        account_id: selectedAccount.AccountId,
        client_documents_id: clientDocumentsId,
      };

      const startDataPolling = async () => {
        const fetchLabellerData = async () => {
          if (isPollingForLabellerData.current) {
            console.log("Polling is already in progress, skipping this call.");
            return;
          }

          isPollingForLabellerData.current = true;
          setIsTransferDataDisabled(true);
          setCanEditSplitDisabled(true);
          setAllDataHasArrived(false);

          console.log("Fetching Labeller Data...");
          try {
            await getLabellerData(
              accountDetails,
              (response) => {
                // Process the response
                if (response.length >= 1) {
                  const responseString = JSON.stringify(response);

                  const allDocumentsProcessed = response
                    .filter((res) => relevantSplitIds.includes(res.splitFileId))
                    .map((res) => {
                      return {
                        splitFileId: res.splitFileId,
                        labellerOutput: res.labeller_output,
                      };
                    })
                    .every((el) => el.labellerOutput);

                  if (lastResponse === responseString) {
                    if (!unchangedSince) {
                      // Start the timer when response first matches
                      unchangedSince = Date.now();
                    } else if (
                      Date.now() - unchangedSince >
                        60000 * TIMEOUT_THRESHOLD_IN_MINS ||
                      allDocumentsProcessed
                    ) {
                      // Stop polling after 3 minutes of unchanged response
                      setSplitFilesData((prevSplitFiles) =>
                        prevSplitFiles.map((file) => ({
                          ...file,
                          hasFailed: !file.splitFiles[0].labellerOutput
                            ? true
                            : undefined,
                        })),
                      );

                      clearInterval(dataPollingInterval);
                      setIsTransferDataDisabled(false);
                      setCanEditSplitDisabled(false);
                      setAllDataHasArrived(true);
                      setLabellerResponse(response);
                      getDocumentBlobs(response);
                      validateSplitFilesData(splitFilesData);

                      return;
                    }
                  } else {
                    // Reset the timer if the response changes
                    lastResponse = responseString;
                    unchangedSince = null;
                  }

                  response.forEach((split) => {
                    const matchedSplitIndex = splitFilesData.findIndex(
                      (splitFile) =>
                        splitFile.splitFiles[0].id === split.splitFileId,
                    );

                    if (matchedSplitIndex !== -1 && split.labeller_output) {
                      setSplitFilesData((prevSplitFiles) =>
                        prevSplitFiles.map((file, index) => {
                          if (index === matchedSplitIndex) {
                            return {
                              ...file,
                              hasProcessed: true,
                              splitFiles: file.splitFiles.map(
                                (splitFile, splitIndex) => {
                                  if (splitIndex === 0) {
                                    return {
                                      ...splitFile,
                                      labellerOutput:
                                        JSON.parse(split.labeller_output)
                                          .files[0].splitFiles[0]
                                          .labellerOutput ||
                                        JSON.parse(split.labeller_output).files
                                          .splitFiles[0].labellerOutput,
                                    };
                                  }
                                  return splitFile;
                                },
                              ),
                            };
                          }
                          return file;
                        }),
                      );
                    }
                  });
                }
              },
              (error) => {
                console.log(`Failed to fetch Labeller Data: ${error}`);
              },
            );
          } catch (error) {
            console.error("Error fetching Labeller Data: ", error);
          } finally {
            isPollingForLabellerData.current = false;
          }
        };

        dataPollingInterval = setInterval(fetchLabellerData, 1000);
        fetchLabellerData();
        console.log("Started polling for Labeller Data every 1 second.");
      };

      const fetchCompletedData = async () => {
        try {
          await getLabellerData(
            accountDetails,
            (response) => {
              // Match response split with splitFilesData split
              response.forEach((split) => {
                const matchedSplitIndex = splitFilesData.findIndex(
                  (splitFile) =>
                    splitFile.splitFiles[0].id === split.splitFileId,
                );

                if (matchedSplitIndex !== -1 && split.labeller_output) {
                  setSplitFilesData((prevSplitFiles) =>
                    prevSplitFiles.map((file, index) => {
                      if (index === matchedSplitIndex) {
                        return {
                          ...file,
                          hasProcessed: true,
                          isEdited:
                            split.labellerStatus === "Updated"
                              ? true
                              : undefined,
                          splitFiles: file.splitFiles.map(
                            (splitFile, splitIndex) => {
                              if (splitIndex === 0) {
                                const lo =
                                  split.labeller_output &&
                                  JSON.parse(split.labeller_output).files
                                    ? JSON.parse(split.labeller_output).files[0]
                                        ?.splitFiles?.[0]?.labellerOutput ||
                                      JSON.parse(split.labeller_output).files
                                        ?.splitFiles?.labellerOutput
                                    : null;
                                return {
                                  ...splitFile,
                                  labellerOutput: lo,
                                };
                              }
                              return splitFile;
                            },
                          ),
                        };
                      }
                      return file;
                    }),
                  );
                }
              });

              // If labellerOutput is undef add hasFailed flag
              setSplitFilesData((prevSplitFiles) =>
                prevSplitFiles.map((file) => ({
                  ...file,
                  hasFailed: !file.splitFiles[0].labellerOutput
                    ? true
                    : undefined,
                })),
              );

              setIsTransferDataDisabled(false);
              setCanEditSplitDisabled(false);
              setLabellerResponse(response);
              setAllDataHasArrived(true);
              // getDocumentBlobs(response);
              validateSplitFilesData(splitFilesData);

              return;
            },
            (error) => {},
          );
        } catch (e) {
          console.log("Error with getLabellerData. ");
        }
      };

      if (oldDocument) {
        console.log("old document true");
        fetchCompletedData();
      } else {
        startDataPolling();
      }

      return () => {
        console.log("Cleaning up polling intervals and timeout.");
        clearInterval(dataPollingInterval);
      };
    } else {
      console.log("Edited documents found, setting documents state.");
      setAllDataHasArrived(true);
      setLabellerResponse(_labellerResponse);
      setSplitFilesData(splitFiles);
      setDocuments(editedDocuments);
      setDocumentsFiles(getFiles() || []);
    }
  }, []);

  console.log("update", allDataHasArrived);

  useEffect(() => {
    console.log("labeller response ", labellerResponse);
    console.log("getFiles length", allDataHasArrived);
    if (getFiles().length === 0 && allDataHasArrived) {
      console.log("Called here. ");
      const reFetchDocuments = async () => {
        setCanEditSplitDisabled(true);
        await getDocumentBlobs(labellerResponse);
        setCanEditSplitDisabled(false);
      };
      reFetchDocuments();
    }
  }, [allDataHasArrived]);

  // useEffect(() => {
  //   console.log("split files ", splitFiles);
  //   const urlParams = new URLSearchParams(window.location.search);
  //   const ntld = urlParams.get("ntld") === "true";
  //
  //   if (!ntld) {
  //     let dataPollingInterval;
  //     let timeoutTimer = null;
  //
  //     const accountDetails = {
  //       account_id: selectedAccount.AccountId,
  //       client_documents_id: clientDocumentsId,
  //     };
  //
  //     const startDataPolling = async () => {
  //       const fetchLabellerData = async () => {
  //         if (isPollingForLabellerData.current) {
  //           console.log("Polling is already in progress, skipping this call.");
  //           return;
  //         }
  //
  //         isPollingForLabellerData.current = true;
  //         setIsProceedDisabled(true);
  //         setCanEditSplitDisabled(true);
  //
  //         console.log("Fetching Labeller Data...");
  //         try {
  //           await getLabellerData(
  //             accountDetails,
  //             (response) => {
  //               console.log("Labeller Data Response: ", response);
  //               const shouldStopPolling = response.length >= splitFiles.length;
  //
  //               if (shouldStopPolling) {
  //                 console.log("All split files processed. Stopping polling.");
  //                 dispatch(getUnderwriterIdpActiveDocuments());
  //                 dispatch(getUnderwriterIdpArchivedDocuments());
  //                 clearInterval(dataPollingInterval);
  //                 setIsProceedDisabled(false);
  //                 setCanEditSplitDisabled(false);
  //                 return;
  //               }
  //
  //               if (oldDocument) {
  //                 console.log(
  //                   "Processing oldDocument logic: Replacing documents.",
  //                 );
  //                 getDocumentBlobs(response);
  //                 setDocuments(response);
  //                 setIsProceedDisabled(false);
  //                 setCanEditSplitDisabled(false);
  //                 clearInterval(dataPollingInterval);
  //               } else {
  //                 console.log(
  //                   "Processing incremental update logic for new elements.",
  //                 );
  //                 const newElements = response.filter((newElement) => {
  //                   const newId = newElement.files[0].splitFiles[0].id;
  //                   const isNew = !previousIdsRef.current.has(newId);
  //                   return isNew;
  //                 });
  //
  //                 if (newElements.length > 0) {
  //                   console.log("New elements found: ", newElements);
  //                   if (timeoutTimer) {
  //                     console.log(
  //                       "Clearing existing timeout as new elements are found.",
  //                     );
  //                     clearTimeout(timeoutTimer);
  //                     timeoutTimer = null; // Reset the timer
  //                   }
  //
  //                   newElements.forEach((element) => {
  //                     const id = element.files[0].splitFiles[0].id;
  //                     previousIdsRef.current.add(id);
  //                   });
  //
  //                   getDocumentBlobs(newElements);
  //
  //                   setDocuments((prevDocuments) => [
  //                     ...prevDocuments,
  //                     ...newElements,
  //                   ]);
  //                   setPreviousResponse((prevResponse) => [
  //                     ...prevResponse,
  //                     ...newElements,
  //                   ]);
  //                 } else {
  //                   console.log(
  //                     "No new elements found. Starting timeout logic.",
  //                   );
  //                   if (!timeoutTimer) {
  //                     console.log(
  //                       "No new elements found. Starting timeout to check for missing files.",
  //                     );
  //
  //                     timeoutTimer = setTimeout(() => {
  //                       console.log(
  //                         "2 minutes passed without new elements. Comparing IDs...",
  //                       );
  //
  //                       const currentIds = new Set(
  //                         response.flatMap((doc) =>
  //                           doc.files.flatMap((file) =>
  //                             file.splitFiles.map((splitFile) => splitFile.id),
  //                           ),
  //                         ),
  //                       );
  //
  //                       console.log("current ids ", currentIds);
  //
  //                       const newFiles = splitFiles.flatMap((file) => {
  //                         return file.splitFiles
  //                           .filter(
  //                             (splitFile) => !currentIds.has(splitFile.id),
  //                           )
  //                           .map((splitFile) => ({
  //                             files: [
  //                               {
  //                                 id: file.id,
  //                                 bucketName: file.bucketName,
  //                                 fileName: file.fileName,
  //                                 filePath: file.filePath,
  //                                 splitFiles: [
  //                                   {
  //                                     ...splitFile,
  //                                     labellerOutput: null, // Add missing elements with `labellerOutput` set to null
  //                                   },
  //                                 ],
  //                               },
  //                             ],
  //                             id: file.filePath.split("/")[0],
  //                           }));
  //                       });
  //
  //                       if (newFiles.length > 0) {
  //                         console.log(
  //                           "Adding missing files to documents: ",
  //                           newFiles,
  //                         );
  //                         setDocuments((prevDocuments) => [
  //                           ...prevDocuments,
  //                           ...newFiles,
  //                         ]);
  //                       }
  //
  //                       console.log(
  //                         "Stopping polling after 2 minutes of inactivity and adding missing data.",
  //                       );
  //
  //                       dispatch(getUnderwriterIdpActiveDocuments());
  //                       dispatch(getUnderwriterIdpArchivedDocuments());
  //                       clearInterval(dataPollingInterval);
  //                       setIsProceedDisabled(false);
  //                       setCanEditSplitDisabled(false);
  //                     }, 60000); // 1 minute for debugging
  //                   }
  //                 }
  //               }
  //             },
  //             (error) => {
  //               console.log(`Failed to fetch Labeller Data: ${error}`);
  //             },
  //           );
  //         } catch (error) {
  //           console.error("Error fetching Labeller Data: ", error);
  //         } finally {
  //           isPollingForLabellerData.current = false;
  //         }
  //       };
  //
  //       dataPollingInterval = setInterval(fetchLabellerData, 1000);
  //       fetchLabellerData();
  //       console.log("Started polling for Labeller Data every 1 second.");
  //     };
  //
  //     startDataPolling();
  //
  //     return () => {
  //       console.log("Cleaning up polling intervals and timeout.");
  //       clearInterval(dataPollingInterval);
  //       clearTimeout(timeoutTimer);
  //     };
  //   } else {
  //     console.log("Edited documents found, setting documents state.");
  //     setDocuments(editedDocuments);
  //     setDocumentsFiles(getFiles() || []);
  //   }
  // }, []);

  useEffect(() => {
    const accountDetails = {
      account_id: selectedAccount.AccountId,
      client_documents_id: clientDocumentsId,
    };

    const fetchAuditTrail = async () => {
      try {
        await getAuditTrailData(
          accountDetails,
          (response) => {
            console.log(response);
            setAuditTrail(response);
          },
          (error) => {
            console.log("error getting the audit trail ", error);
          },
        );
      } catch (e) {
        console.log("error with getAuditTrailData");
      }
    };
    fetchAuditTrail();
  }, []);

  // if the user exits the IDP process at this stage clear files so files won't persist from this run through to the next one
  useEffect(() => {
    const unListen = history.listen((location) => {
      if (
        !location.pathname.includes("/underwriter/idpdocuments/labeleditor")
      ) {
        setFiles([]);
      }
    });

    return () => unListen();
  }, [history, setFiles]);

  const validateSplitFilesData = (splitFilesData) => {
    const getNewestId = (splitFile) => {
      let ids = [];
      splitFile.labellerOutput
        .filter(
          (entity) =>
            entity.type ===
            (splitFile.labellerModel === "profitAndLoss" ||
            splitFile.labellerModel === "cashflow" ||
            splitFile.labellerModel === "balanceSheet"
              ? "year"
              : "project"),
        )
        .forEach(({ properties }) => {
          properties.forEach((property) => {
            ids.push(parseInt(property.id));
          });
        });

      return Math.max(...ids);
    };

    const pushPropertyIfMissing = (type, value, documentType) => {
      splitFilesData.forEach((file) => {
        const { entities } = file.splitFiles[0].labellerOutput;

        entities.forEach((entity) => {
          if (entity.type === documentType) {
            if (!entity.properties.includes((e) => e.type === type)) {
              let currentId = getNewestId(file.splitFiles[0]);

              entity.properties.push({
                id: (++currentId).toString(),
                type,
                mentionText: value,
                confidence: 0,
              });
            }
          }
        });
      });
    };

    const balanceSheetReportingDates = splitFilesData
      .find((file) => file.splitFiles[0].labellerModel === "balanceSheet")
      .splitFiles[0].entities.find(
        (entity) => entity.type === "reporting-dates",
      ).mentionText;

    const profitAndLossReportingDates = splitFilesData
      .find((file) => file.splitFiles[0].labellerModel === "profitAndLoss")
      .splitFiles[0].entities.find(
        (entity) => entity.type === "reporting-dates",
      ).mentionText;

    const cashflowReportingDates = splitFilesData
      .find((file) => file.splitFiles[0].labellerModel === "cashflow")
      .splitFiles[0].entities.find(
        (entity) => entity.type === "reporting-dates",
      ).mentionText;

    const currentReportingDate = new Date().toLocaleDateString("en-US", {
      year: "numeric",
      month: "long",
      day: "numeric",
    });

    pushPropertyIfMissing(
      "as_of_date",
      balanceSheetReportingDates ||
        profitAndLossReportingDates ||
        cashflowReportingDates ||
        currentReportingDate,
      "project",
    );

    pushPropertyIfMissing("company-name", "Unnamed Company", "project");
  };

  const handleTransferData = async () => {
    console.log("docs before augmentation", splitFilesData);

    const splitFilesDataWithoutFailedDocs = splitFilesData.filter(
      (doc) => !doc.hasFailed,
    );

    // const processedDocs = new Map();
    //
    // splitFilesDataWithoutFailedDocs.forEach((doc) => {
    //   const labellerModel = doc.splitFiles[0]?.labellerModel;
    //
    //   if (labellerModel) {
    //     if (processedDocs.has(labellerModel)) {
    //       const firstDoc = processedDocs.get(labellerModel);
    //       firstDoc.splitFiles[0].labellerOutput.entities.push(
    //         ...doc.splitFiles[0].labellerOutput.entities,
    //       );
    //     } else {
    //       processedDocs.set(labellerModel, doc);
    //     }
    //   }
    // });
    //
    // const combinedSplitFilesData = Array.from(processedDocs.values());

    const data = splitFilesDataWithoutFailedDocs.map((res) => {
      return {
        id: splitFilesDataWithoutFailedDocs[0].filePath.split("/")[0],
        files: [res],
      };
    });

    const transferData = {
      account_id: selectedAccount.AccountId,
      client_documents_id: clientDocumentsId,
      transfer_data: data,
    };

    console.log("Location state:", location.state);

    console.log("transfer data ", transferData);

    setIsTransferDataDisabled(true);

    try {
      await postTransferData(
        transferData,
        (response) => {
          updateIdpDocumentCounter({
            idp_doc_count: --selectedAccount.documentsCount,
          })
            .then((res) => console.log(res))
            .catch((err) => console.log("Couldn't reduce the count"));
          setShowTransferDataPopup(true);
        },
        (error) => {
          setShowFailedTransferDataPopup(true);
          console.log("transfer data failed with ", error);
        },
      );
      dispatch(getUnderwriterIdpActiveDocuments());
      dispatch(getUnderwriterIdpArchivedDocuments());
    } catch (e) {
      setShowFailedTransferDataPopup(true);
      console.log("error with postTransferData ", e);
    } finally {
      setIsTransferDataDisabled(false);
    }
  };

  // const getDocumentBlobs = async (res) => {
  //   const pdfFiles = [];
  //   const promises = [];
  //
  //   res.forEach((item) => {
  //     if (!Array.isArray(item.files)) {
  //       console.log("Single file, no array");
  //
  //       const promise = getPdfDocsFromBucket({
  //         bucketName: item.files.splitFiles.bucketName,
  //         filePath: item.files.splitFiles.filePath,
  //       }).then((fetchedBlobs) => {
  //         const matchingBlob = fetchedBlobs.find(
  //           (fetchedBlob) =>
  //             fetchedBlob.fileName === item.files.splitFiles.fileName,
  //         );
  //
  //         if (matchingBlob) {
  //           console.log(
  //             `Found matching blob for ${item.files.splitFiles.fileName}`,
  //           );
  //           pdfFiles.push({
  //             fileName: item.files.splitFiles.fileName,
  //             blob: matchingBlob.blob,
  //             splitId: item.files.splitFiles.id,
  //           });
  //         } else {
  //           console.warn(
  //             `No matching blob found for ${item.files.splitFiles.fileName}`,
  //           );
  //         }
  //       });
  //
  //       promises.push(promise);
  //     } else {
  //       console.log("Processing array of files");
  //
  //       item.files.forEach((file, fileIndex) => {
  //         console.log(`Processing file at index ${fileIndex}`);
  //
  //         file.splitFiles.forEach((splitFile, splitIndex) => {
  //           console.log(
  //             `Processing split file at index ${splitIndex} with fileName ${splitFile.fileName}`,
  //           );
  //
  //           const promise = getPdfDocsFromBucket({
  //             bucketName: splitFile.bucketName,
  //             filePath: splitFile.filePath,
  //           }).then((fetchedBlobs) => {
  //             const matchingBlob = fetchedBlobs.find(
  //               (fetchedBlob) => fetchedBlob.fileName === splitFile.fileName,
  //             );
  //
  //             if (matchingBlob) {
  //               console.log(`Found matching blob for ${splitFile.fileName}`);
  //               pdfFiles.push({
  //                 fileName: splitFile.fileName,
  //                 blob: matchingBlob.blob,
  //                 splitId: splitFile.id,
  //               });
  //             } else {
  //               console.warn(
  //                 `No matching blob found for ${splitFile.fileName}`,
  //               );
  //             }
  //           });
  //
  //           promises.push(promise);
  //         });
  //       });
  //     }
  //   });
  //   return Promise.all(promises)
  //     .then(() => {
  //       setDocumentsFiles((prevDocuments) => {
  //         setFiles([...prevDocuments, ...pdfFiles]);
  //         return [...prevDocuments, ...pdfFiles];
  //       });
  //
  //       console.log("pdf files ", pdfFiles);
  //       console.log("files ", getFiles());
  //     })
  //     .catch((error) => {
  //       console.error("Error fetching documents:", error);
  //     });
  // };

  const getDocumentBlobs = async (res) => {
    if (!res) return;

    const pdfFiles = [];
    const promises = [];

    res.forEach((file) => {
      const matchedDocument = splitFilesData.find(
        (splitFile) => splitFile.splitFiles[0].id === file.splitFileId,
      );

      if (matchedDocument) {
        const { bucketName, filePath, fileName, id } =
          matchedDocument.splitFiles[0];

        const promise = getPdfDocsFromBucket({
          bucketName,
          filePath,
        }).then((fetchedBlobs) => {
          const matchingBlob = fetchedBlobs.find(
            (fetchedBlob) => fetchedBlob.fileName === fileName,
          );

          if (matchingBlob) {
            console.log(`Found matching blob for ${fileName}`);

            pdfFiles.push({
              fileName,
              blob: matchingBlob.blob,
              splitId: id,
            });
          } else {
            console.log(`Warning: No matching blob found for ${fileName}`);
          }
        });

        promises.push(promise);
      }
    });

    return Promise.all(promises)
      .then(() => {
        setDocumentsFiles((prevDocuments) => {
          setFiles([...prevDocuments, ...pdfFiles]);
          return [...prevDocuments, ...pdfFiles];
        });

        console.log("pdf files ", pdfFiles);
        console.log("files ", getFiles());
      })
      .catch((error) => {
        console.error("Error fetching documents:", error);
      });
  };

  const handleEditDocument = (
    splitFile,
    pdfBlob,
    index,
    documentFiles,
    documentId,
    file,
  ) => {
    console.log("split file parser screen ", splitFile);
    console.log("file parser screen ", file);

    history.push({
      pathname: "/underwriter/idpdocuments/labeleditor",
      state: {
        splitFile,
        pdfBlob,
        selectedAccount,
        clientDocumentsId,
        splitFiles: splitFilesData,
        labellerResponse,
        index,
        documentId,
        file,
      },
    });
  };

  const handleClose = () => {
    setShowTransferDataPopup(false);
  };

  const getFileProperty = (files, property) => {
    if (Array.isArray(files)) {
      return files[0]?.splitFiles[0]?.[property];
    }
    return files.splitFiles?.[property];
  };

  return (
    <>
      <Dialog
        open={showDeleteDocumentTypeConfirmationPopup}
        setOpen={setShowDeleteDocumentTypeConfirmationPopup}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        maxWidth="md"
      >
        <StyledPaper elevation={0}>
          <CloseButton
            onClick={() => {
              setShowDeleteDocumentTypeConfirmationPopup(false);
              setDocumentTypeToDelete(null);
            }}
          >
            <CloseIcon />
          </CloseButton>
          <img src={PylonIcon} />
          <FormTitle
            style={{
              marginTop: "30px",
              marginBottom: "20px",
              color: "#1A051D",
              fontSize: "22px",
              fontWeight: "600",
              fontStyle: "normal",
              lineHeight: "24px",
            }}
          >
            Exclude From Transfer Data
          </FormTitle>
          <SmallTitleText
            style={{
              marginBottom: 10,
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
              maxWidth: "100%",
            }}
          >
            Are you sure you want to exclude{" "}
            <strong>
              {documentTypeToDelete
                ? modelMappings[documentTypeToDelete.labellerModel]
                : "this document type"}{" "}
            </strong>
            from transfer data?
          </SmallTitleText>
          <FunctionalButton
            buttonTitle="Confirm"
            width="308px"
            height="48px"
            isReversedColor={false}
            marginRight={"48px"}
            marginLeft={"48px"}
            marginTop={"30px"}
            marginBottom={"20px"}
            fontSize={"18px"}
            disabled={false}
            icon={null}
            hasBoxShadow={true}
            frontIcon={null}
            weight={600}
          />
        </StyledPaper>
      </Dialog>
      <AlertPopup
        headerText="Data Transfer Unsuccessful"
        height="434px"
        subHeaderText="We encountered an issue transferring your data. If the problem persists, contact PledgX support for assistance."
        openPopup={showFailedTransferDataPopup}
        setOpenPopup={setShowFailedTransferDataPopup}
        showIcon={true}
        width={"640px"}
        showButton={false}
      />
      <Dialog
        open={showTransferDataPopup}
        setOpen={setShowTransferDataPopup}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        maxWidth="md"
      >
        <StyledPaper elevation={0}>
          <CloseButton aria-label="close" onClick={handleClose}>
            <CloseIcon />
          </CloseButton>
          <Success />
          <FormTitle
            style={{
              marginTop: "10px",
              color: "#1A051D",
              fontSize: "22px",
              fontWeight: "600",
              fontStyle: "normal",
              lineHeight: "24px",
            }}
          >
            Your data has been transferred
          </FormTitle>
          <SmallTitleText
            style={{
              marginBottom: 10,
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
              maxWidth: "100%",
            }}
          >
            Your document(s) can now be accessed from the archive.
          </SmallTitleText>
          <InfoArea>
            <FunctionalButton
              buttonTitle="Go Back"
              handleButton={() => {
                history.push("/underwriter-dashboard");
              }}
              width="308px"
              height="48px"
              isReversedColor={true}
              marginRight={"48px"}
              marginLeft={"48px"}
              marginTop={"30px"}
              marginBottom={"20px"}
              fontSize={"18px"}
              disabled={false}
              icon={null}
              hasBoxShadow={true}
              frontIcon={null}
              weight={600}
            />
            <FunctionalButton
              buttonTitle="Upload New"
              handleButton={() => {
                history.push("/underwriter/idpdocuments");
              }}
              width="308px"
              height="48px"
              isReversedColor={false}
              marginRight={"48px"}
              marginLeft={"48px"}
              marginTop={"30px"}
              marginBottom={"20px"}
              fontSize={"18px"}
              disabled={false}
              icon={null}
              hasBoxShadow={true}
              frontIcon={null}
              weight={600}
            />
          </InfoArea>
        </StyledPaper>
      </Dialog>
      <ScreenRoot>
        <VerticalContainer>
          <HorizontalContainer>
            <TitleContainer>
              <LargeText>{selectedAccount.CompanyName}</LargeText>
              <MediumText>{selectedAccount.AccountId}</MediumText>
            </TitleContainer>
            <StageList
              stages={["Uploader", "Splitter", "Classifier", "Parser"]}
              currentStage="Parser"
            />
            <ProceedButtonContainer>
              <FunctionalButton
                tooltip="This action is irreversible. Ensure that data is accurate, by viewing and/or editing each document, before proceeding with data transfer"
                buttonTitle="Transfer Data"
                handleButton={handleTransferData}
                width="100%"
                height="48px"
                isReversedColor={false}
                marginRight={"48px"}
                marginLeft={"48px"}
                marginTop={"48px"}
                marginBottom={"48px"}
                fontSize={"16px"}
                disabled={isTransferDataDisabled}
                icon={null}
                hasBoxShadow={true}
                frontIcon={null}
                weight={600}
              />
            </ProceedButtonContainer>
          </HorizontalContainer>

          <TabContainer>
            <TabButton
              active={selectedTab === "documents"}
              onClick={() => setSelectedTab("documents")}
            >
              Documents
              <TabButtonSpan> ({splitFiles?.length || 0})</TabButtonSpan>
            </TabButton>
            <TabButton
              active={selectedTab === "audit_trail"}
              onClick={() => setSelectedTab("audit_trail")}
            >
              Audit Trail
              <TabButtonSpan> ({auditTrail?.length || 0})</TabButtonSpan>
            </TabButton>
          </TabContainer>

          {selectedTab === "documents" && (
            <StyledTable>
              <thead>
                <StyledTableRow header={true}>
                  <StyledTableCell style={{ fontSize: "16px" }} header={true}>
                    ID
                  </StyledTableCell>
                  <StyledTableCell style={{ fontSize: "16px" }} header={true}>
                    Document Type
                  </StyledTableCell>
                  <StyledTableCell style={{ fontSize: "16px" }} header={true}>
                    Status
                  </StyledTableCell>
                  <StyledTableCell style={{ fontSize: "16px" }} header={true}>
                    View/Edit
                  </StyledTableCell>
                </StyledTableRow>
              </thead>
              <tbody>
                {splitFilesData &&
                  splitFilesData.map((file, index) => (
                    <StyledTableRow key={file.splitFiles[0].id}>
                      <StyledTableCell style={{ fontSize: "16px" }}>
                        {file.splitFiles[0].id}
                      </StyledTableCell>
                      <StyledTableCell style={{ fontSize: "16px" }}>
                        {modelMappings[file.splitFiles[0].labellerModel]}
                      </StyledTableCell>
                      <StyledTableCell style={{ fontSize: "16px" }}>
                        {(() => {
                          if (file.hasFailed) {
                            return "Failed";
                          } else if (file.hasProcessed && !file.isEdited) {
                            return "Original";
                          } else if (file.isEdited) {
                            return "Edited";
                          } else {
                            return "Pending";
                          }
                        })()}
                      </StyledTableCell>
                      <StyledTableCell style={{ fontSize: "16px" }}>
                        {!file.hasFailed && (
                          <FunctionButtonContainer>
                            {!canEditSplitDisabled ? (
                              <ActionButton
                                onClick={() => {
                                  console.log("cklkk", getFiles());
                                  const matchedDocument = getFiles().find(
                                    (doc) =>
                                      doc.splitId == file.splitFiles[0].id,
                                  );

                                  console.log("getFiles() ", getFiles());

                                  if (matchedDocument) {
                                    console.log(
                                      "matched split file ",
                                      file.splitFiles[0].id,
                                    );
                                    console.log(
                                      "matched document ",
                                      matchedDocument,
                                    );

                                    const newSplitFile = {
                                      ...file.splitFiles[0],
                                    };

                                    const documentId =
                                      file.filePath.split("/")[0];

                                    handleEditDocument(
                                      newSplitFile,
                                      matchedDocument.blob,
                                      index,
                                      documentFiles,
                                      documentId,
                                      file,
                                    );
                                  } else {
                                    console.log(
                                      "Couldn't find a matched document for this split.",
                                    );
                                  }
                                }}
                                disabled={!file.splitFiles[0].labellerOutput} // Disable button if labellerOutput is undefined
                              >
                                <EditIcon />
                              </ActionButton>
                            ) : (
                              <Spinner size="22px" />
                            )}
                            {/*<ActionButton*/}
                            {/*  onClick={() => {*/}
                            {/*    setShowDeleteDocumentTypeConfirmationPopup(true);*/}
                            {/*    setDocumentTypeToDelete(file.splitFiles[0]);*/}
                            {/*  }}*/}
                            {/*>*/}
                            {/*  <DeleteIcon />*/}
                            {/*</ActionButton>*/}
                          </FunctionButtonContainer>
                        )}
                      </StyledTableCell>
                    </StyledTableRow>
                  ))}
              </tbody>
            </StyledTable>
          )}

          {selectedTab === "audit_trail" && (
            <StyledTable>
              <thead>
                <StyledTableRow header={true}>
                  <StyledTableCell style={{ fontSize: "16px" }} header={true}>
                    Time
                  </StyledTableCell>
                  <StyledTableCell style={{ fontSize: "16px" }} header={true}>
                    Event
                  </StyledTableCell>
                  <StyledTableCell style={{ fontSize: "16px" }} header={true}>
                    User
                  </StyledTableCell>
                  <StyledTableCell style={{ fontSize: "16px" }} header={true}>
                    Description
                  </StyledTableCell>
                </StyledTableRow>
              </thead>
              <tbody>
                {auditTrail &&
                  auditTrail.map((event) => (
                    <StyledTableRow key={event.id}>
                      <StyledTableCell style={{ fontSize: "16px" }}>
                        {event.created_at}
                      </StyledTableCell>
                      <StyledTableCell style={{ fontSize: "16px" }}>
                        {event.event_name}
                      </StyledTableCell>
                      <StyledTableCell style={{ fontSize: "16px" }}>
                        {event.auditor_name}
                      </StyledTableCell>
                      <StyledTableCell style={{ fontSize: "16px" }}>
                        {event.event_description}
                      </StyledTableCell>
                    </StyledTableRow>
                  ))}
              </tbody>
            </StyledTable>
          )}
        </VerticalContainer>
      </ScreenRoot>
    </>
  );
}

const EditIcon = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_1744_575)">
      <path
        d="M15.4864 0.500019C16.1662 0.502058 16.8176 0.772743 17.2983 1.25297L18.6853 2.63071C18.9426 2.87469 19.1476 3.16847 19.2877 3.49416C19.4278 3.81984 19.5 4.17062 19.5 4.5251C19.5 4.87958 19.4278 5.23035 19.2877 5.55604C19.1476 5.88173 18.9426 6.17551 18.6853 6.41949L11.4699 13.6286C10.3235 14.7981 9.17701 15.9355 8.02255 17.0729C7.90697 17.1876 7.76731 17.2752 7.61368 17.3293C5.52924 18.0341 3.43679 18.723 1.35235 19.4199C1.23457 19.4664 1.11002 19.4934 0.983563 19.5C0.902828 19.4953 0.824337 19.4717 0.754491 19.431C0.684644 19.3903 0.625421 19.3336 0.581651 19.2657C0.537882 19.1977 0.510805 19.1204 0.502629 19.04C0.494453 18.9596 0.50541 18.8785 0.534607 18.8031L1.85742 14.7981C2.13 13.9971 2.39457 13.196 2.65913 12.395C2.70283 12.2623 2.77695 12.1416 2.87559 12.0426L13.5784 1.30904C13.825 1.05206 14.1213 0.84784 14.4493 0.708768C14.7773 0.569695 15.1301 0.498675 15.4864 0.500019ZM13.0813 3.3356L3.98996 12.395L7.5736 15.9996L16.665 6.93214L13.0813 3.3356ZM17.4747 6.17118C17.6591 5.98694 17.8595 5.81072 18.0359 5.61848C18.3076 5.33019 18.4589 4.94913 18.4589 4.55313C18.4589 4.15714 18.3076 3.77608 18.0359 3.48779C17.5388 2.95111 17.0177 2.44648 16.4966 1.94985C16.3272 1.7908 16.1232 1.67327 15.9006 1.60655C15.678 1.53982 15.4429 1.52572 15.2139 1.56536C14.6551 1.72676 14.1667 2.07088 13.8269 2.5426L17.4747 6.17118ZM1.84941 18.1863L6.5875 16.5843L3.41274 13.4283L1.84941 18.1863Z"
        fill="#B9B9C3"
      />
      <path
        d="M17.2983 1.25297L17.2276 1.32372L17.2278 1.32391L17.2983 1.25297ZM18.6853 2.63071L18.6148 2.70167L18.6165 2.70328L18.6853 2.63071ZM18.6853 6.41949L18.6164 6.34689L18.6146 6.34875L18.6853 6.41949ZM11.4699 13.6286L11.3992 13.5578L11.3985 13.5586L11.4699 13.6286ZM8.02255 17.0729L7.95237 17.0017L7.95212 17.0019L8.02255 17.0729ZM7.61368 17.3293L7.64572 17.424L7.64689 17.4236L7.61368 17.3293ZM1.35235 19.4199L1.3206 19.3249L1.31566 19.3269L1.35235 19.4199ZM0.983563 19.5L0.977777 19.6004L0.98877 19.5999L0.983563 19.5ZM0.534607 18.8031L0.627971 18.8393L0.629561 18.8345L0.534607 18.8031ZM1.85742 14.7981L1.76275 14.7658L1.76247 14.7667L1.85742 14.7981ZM2.65913 12.395L2.75409 12.4264L2.75411 12.4263L2.65913 12.395ZM2.87559 12.0426L2.80478 11.972L2.80474 11.972L2.87559 12.0426ZM13.5784 1.30904L13.6492 1.37966L13.6505 1.37828L13.5784 1.30904ZM13.0813 3.3356L13.1522 3.26501L13.0816 3.19417L13.0107 3.26476L13.0813 3.3356ZM3.98996 12.395L3.91938 12.3242L3.84862 12.3947L3.91905 12.4655L3.98996 12.395ZM7.5736 15.9996L7.50268 16.0701L7.5733 16.1411L7.64421 16.0704L7.5736 15.9996ZM16.665 6.93214L16.7356 7.00294L16.8063 6.93236L16.7358 6.86155L16.665 6.93214ZM17.4747 6.17118L17.4042 6.24207L17.4748 6.31238L17.5454 6.24192L17.4747 6.17118ZM18.0359 5.61848L17.9631 5.54988L17.9622 5.55087L18.0359 5.61848ZM18.4589 4.55313H18.5589H18.4589ZM18.0359 3.48779L17.9625 3.55574L17.9631 3.55638L18.0359 3.48779ZM16.4966 1.94985L16.5656 1.87746L16.5651 1.87696L16.4966 1.94985ZM15.2139 1.56536L15.1967 1.46623L15.1861 1.46929L15.2139 1.56536ZM13.8269 2.5426L13.7458 2.48415L13.6959 2.55335L13.7564 2.61349L13.8269 2.5426ZM1.84941 18.1863L1.7544 18.1551L1.69197 18.3451L1.88144 18.2811L1.84941 18.1863ZM6.5875 16.5843L6.61953 16.6791L6.77258 16.6273L6.658 16.5134L6.5875 16.5843ZM3.41274 13.4283L3.48324 13.3574L3.36831 13.2432L3.31773 13.3971L3.41274 13.4283ZM15.4861 0.600018C16.1395 0.601979 16.7656 0.862157 17.2276 1.32372L17.369 1.18222C16.8696 0.683329 16.1929 0.402138 15.4867 0.400019L15.4861 0.600018ZM17.2278 1.32391L18.6148 2.70165L18.7557 2.55976L17.3688 1.18202L17.2278 1.32391ZM18.6165 2.70328C18.864 2.93792 19.0611 3.22046 19.1958 3.53367L19.3796 3.45465C19.2341 3.11648 19.0213 2.81145 18.7541 2.55813L18.6165 2.70328ZM19.1958 3.53367C19.3305 3.84687 19.4 4.1842 19.4 4.5251H19.6C19.6 4.15703 19.525 3.79281 19.3796 3.45465L19.1958 3.53367ZM19.4 4.5251C19.4 4.86599 19.3305 5.20332 19.1958 5.51653L19.3796 5.59555C19.525 5.25738 19.6 4.89317 19.6 4.5251H19.4ZM19.1958 5.51653C19.0611 5.82974 18.864 6.11227 18.6165 6.34691L18.7541 6.49207C19.0213 6.23875 19.2341 5.93372 19.3796 5.59555L19.1958 5.51653ZM18.6146 6.34875L11.3992 13.5578L11.5406 13.6993L18.7559 6.49023L18.6146 6.34875ZM11.3985 13.5586C10.2527 14.7274 9.10669 15.8644 7.95237 17.0017L8.09274 17.1442C9.24733 16.0066 10.3943 14.8687 11.5413 13.6986L11.3985 13.5586ZM7.95212 17.0019C7.84707 17.1062 7.72012 17.1858 7.58047 17.2349L7.64689 17.4236C7.8145 17.3646 7.96688 17.269 8.09298 17.1439L7.95212 17.0019ZM7.58165 17.2345C5.49735 17.9394 3.40574 18.628 1.32064 19.3251L1.38406 19.5147C3.46784 18.8181 5.56113 18.1289 7.64572 17.424L7.58165 17.2345ZM1.31566 19.3269C1.20793 19.3694 1.09402 19.3941 0.978355 19.4001L0.98877 19.5999C1.12602 19.5927 1.2612 19.5633 1.38904 19.5129L1.31566 19.3269ZM0.989313 19.4002C0.924299 19.3964 0.861096 19.3774 0.804859 19.3446L0.704123 19.5174C0.787578 19.566 0.881357 19.5943 0.977812 19.5998L0.989313 19.4002ZM0.804859 19.3446C0.748622 19.3118 0.700948 19.2662 0.665716 19.2115L0.497586 19.3198C0.549895 19.401 0.620666 19.4687 0.704123 19.5174L0.804859 19.3446ZM0.665716 19.2115C0.630486 19.1568 0.608695 19.0946 0.602116 19.0299L0.403142 19.0501C0.412914 19.1462 0.445277 19.2386 0.497586 19.3198L0.665716 19.2115ZM0.602116 19.0299C0.595536 18.9652 0.604354 18.8999 0.627851 18.8393L0.441362 18.767C0.406467 18.857 0.39337 18.9541 0.403142 19.0501L0.602116 19.0299ZM0.629561 18.8345L1.95238 14.8294L1.76247 14.7667L0.439652 18.7718L0.629561 18.8345ZM1.95209 14.8303C2.22484 14.0288 2.48955 13.2273 2.75409 12.4264L2.56418 12.3637C2.29959 13.1648 2.03517 13.9653 1.76275 14.7658L1.95209 14.8303ZM2.75411 12.4263C2.79294 12.3084 2.8588 12.2012 2.94645 12.1132L2.80474 11.972C2.69511 12.0821 2.61272 12.2162 2.56415 12.3638L2.75411 12.4263ZM2.9464 12.1132L13.6492 1.37965L13.5076 1.23843L2.80478 11.972L2.9464 12.1132ZM13.6505 1.37828C13.8877 1.13108 14.1728 0.93462 14.4883 0.800834L14.4102 0.616701C14.0698 0.76106 13.7622 0.973049 13.5062 1.2398L13.6505 1.37828ZM14.4883 0.800834C14.8038 0.667047 15.1433 0.598725 15.4861 0.600018L15.4868 0.400019C15.117 0.398624 14.7507 0.472343 14.4102 0.616701L14.4883 0.800834ZM13.0107 3.26476L3.91938 12.3242L4.06055 12.4659L13.1519 3.40643L13.0107 3.26476ZM3.91905 12.4655L7.50268 16.0701L7.64451 15.9291L4.06088 12.3245L3.91905 12.4655ZM7.64421 16.0704L16.7356 7.00294L16.5943 6.86133L7.50298 15.9288L7.64421 16.0704ZM16.7358 6.86155L13.1522 3.26501L13.0105 3.40618L16.5941 7.00272L16.7358 6.86155ZM17.5454 6.24192C17.7226 6.06479 17.9322 5.87942 18.1096 5.68608L17.9622 5.55087C17.7868 5.74203 17.5955 5.9091 17.404 6.10043L17.5454 6.24192ZM18.1086 5.68707C18.3978 5.38023 18.5589 4.97464 18.5589 4.55313H18.3589C18.3589 4.92362 18.2173 5.28015 17.9631 5.54989L18.1086 5.68707ZM18.5589 4.55313C18.5589 4.13163 18.3978 3.72604 18.1086 3.4192L17.9631 3.55638C18.2173 3.82612 18.3589 4.18265 18.3589 4.55313H18.5589ZM18.1092 3.41984C17.6099 2.88072 17.0869 2.37427 16.5656 1.87746L16.4276 2.02224C16.9485 2.51868 17.4677 3.0215 17.9625 3.55574L18.1092 3.41984ZM16.5651 1.87696C16.3844 1.7073 16.1668 1.58193 15.9293 1.51076L15.8719 1.70234C16.0797 1.76462 16.2701 1.87431 16.4281 2.02274L16.5651 1.87696ZM15.9293 1.51076C15.6918 1.43958 15.4411 1.42454 15.1968 1.46683L15.2309 1.6639C15.4447 1.6269 15.6641 1.64006 15.8719 1.70234L15.9293 1.51076ZM15.1861 1.46929C14.6058 1.6369 14.0986 1.99426 13.7458 2.48415L13.9081 2.60104C14.2347 2.1475 14.7043 1.81663 15.2416 1.66144L15.1861 1.46929ZM13.7564 2.61349L17.4042 6.24207L17.5452 6.10028L13.8974 2.4717L13.7564 2.61349ZM1.88144 18.2811L6.61953 16.6791L6.55547 16.4896L1.81738 18.0916L1.88144 18.2811ZM6.658 16.5134L3.48324 13.3574L3.34223 13.4993L6.517 16.6552L6.658 16.5134ZM3.31773 13.3971L1.7544 18.1551L1.94441 18.2176L3.50774 13.4596L3.31773 13.3971Z"
        fill="#B9B9C3"
      />
    </g>
    <defs>
      <clipPath id="clip0_1744_575">
        <rect width="20" height="20" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
